import React, { useState, useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import css from "./index.module.scss";
import i18n from "i18next";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";

const servie = [
  { name: "信息技术服务外包(ITO)", path: "/service/ito" },
  { name: "业务流程外包(BPO)", path: "/service/bpo" },
];
const product = [
  { name: "线上统一支付收银台", path: "/prodandsolution/prod/pay" },
  { name: "对账云平台", path: "/prodandsolution/prod/cloud" },
  { name: "POS-MIS", path: "/prodandsolution/prod/posmis" },
  { name: "分账系统", path: "/prodandsolution/prod/fz" },
  { name: "UPAY", path: "/prodandsolution/prod/upay" },
  { name: "银医通", path: "/prodandsolution/prod/yyt" },
  { name: "银校通", path: "/prodandsolution/prod/yxt" },
  { name: "小微云店", path: "/prodandsolution/prod/xwyd" },
];
const solutions = [
  { name: "$singlee_cr1", path: "/prodandsolution/solution/retail" },
  { name: "$singlee_yl1", path: "/prodandsolution/solution/medical" },
  { name: "$singlee_pk1", path: "/prodandsolution/solution/park" },
  { name: "$singlee_sc1", path: "/prodandsolution/solution/school" },
];
const newsList = [
  { name: "$singlee_nw1", path: "/news/center" },
  { name: "$singlee_nw3", path: "/news/paper" },
]

const aboutusList = [
  { name: "$singlee_ab_md1", path: "/about/brief" },
  { name: "$singlee_ab_md2", path: "/about/director" },
  { name: "$singlee_ab_md3", path: "/about/history" },
  { name: "$singlee_ab_md4", path: "/about/honor" },
  { name: "$singlee_ab_md5", path: "/about/partner" },
];
const joinusList = [
  { name: "加入我们", path: "/join/joinus" },
  { name: "留言板", path: "/join/board" },
];
const routes = {
  home: "/",
  about: "/about",
  brief: "/about/brief",
  prod: "/prodandsolution/prod",
  solution: "/prodandsolution/solution",
  service: "/service",
  ito: "/service/ito",
  bpo: "/service/bpo",
  news: "/news",
  newscenter: "/news/center",
  notice: "/notice",
  join: "/join",
  joinus: "/join/joinus",
  board: "/join/board",
};

const Nav = (props) => {
  const { t } = useTranslation();
  const location = useLocation();
  const paths = location.pathname.split("/");
  const { styles, alwaysNotTransparant } = props;
  const [transparent, setTransparent] = useState(true);
  const navigate = useNavigate();
  const [mobile, setMobile] = useState(window.innerWidth < 1025);
  const [isClick, setIsClick] = useState(false);
  const [isJoin, setIsJoin] = useState(1); // 1-产品 4-服务 2-关于我们 3-搜索
  const [prodFold, setProdFold] = useState(false);
  const [servieFold, setServieFold] = useState(false);
  const [solutionFold, setSolutionFold] = useState(false);
  const [newsFold, setNewsFold] = useState(false);
  const [keyword, setKeyword] = useState("");
  const heightel = useRef(null);
  const [wdHeight, setWdHeight] = useState(-100);
  const [lang, setLang] = useState("zh");

  const getScrollY = () => {
    return window.scrollY || window.pageYOffset;
  };
  const open = (e) => {
    e.stopPropagation();
    // e.nativeEvent.stopImmediatePropagation();
    setIsJoin(1);
    setIsClick(true);
  };
  const open2 = (e) => {
    e.stopPropagation();
    // e.nativeEvent.stopImmediatePropagation();
    setIsJoin(2);
    setIsClick(true);
  };
  const open3 = (e) => {
    e.stopPropagation();
    // e.nativeEvent.stopImmediatePropagation();
    setIsJoin(3);
    setIsClick(true);
  };
  const open4 = (e) => {
    e.stopPropagation();
    // e.nativeEvent.stopImmediatePropagation();
    setIsJoin(4);
    setIsClick(true);
  };
  const close = () => {
    setIsClick(false);
    setKeyword("");
  };
  const serviceOpen = (e) => {
    e.stopPropagation();
    setServieFold(!servieFold);
  };
  const newsOpen = (e) => {
    e.stopPropagation();
    setNewsFold(!newsFold);
  };
  const productOpen = (e) => {
    e.stopPropagation();
    setProdFold(!prodFold);
  };
  const solutionOpen = (e) => {
    e.stopPropagation();
    setSolutionFold(!solutionFold);
  };
  const goNavigate = (path) => {
    navigate(path);
    // window.scrollTo(0, 0);
    close();
  };

  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng.target.value);
    setLang(lng.target.value);
  };
  const switchLanguage = () => {
    if (i18n.language === "zh") {
      setLang("en");
      i18n.changeLanguage("en");
    } else {
      setLang("zh");
      i18n.changeLanguage("zh");
    }
  };
  const goTo = (str) => {
    navigate(routes[str]);
    // window.scrollTo(0, 0);
    close();
  };
  const handleKeyUp = (e) => {
    if (e.keyCode === 13) {
      goSearch();
    }
  };
  const handleChangeIpt = (e) => {
    setKeyword(e.target.value);
  };
  const goSearch = () => {
    if (!keyword || !keyword.length) {
      toast.warning(t("查询关键字不得为空！"), { position: "top-center" });
      return;
    }
    navigate("/search?keyword=" + keyword);
    // window.location.reload();
  };

  useEffect(() => {
    const handleResize = () => {
      setMobile(window.innerWidth < 1025);
      if (heightel.current) {
        setWdHeight(heightel.current.getBoundingClientRect().top - 100);
      }
    };
    const handleScroll = () => {
      const scrollTop = getScrollY();
      // 根据滚动位置判断是否添加背景色
      setTransparent(!(scrollTop > 0));
    };

    window.addEventListener("scroll", handleScroll);

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  useEffect(() => {
    if (heightel.current) {
      setWdHeight(heightel.current.getBoundingClientRect().top - 100);
    }
  }, [isClick, lang]);

  return (
    <>
      {mobile ? (
        <div>
          <div className={css.mobile}>
            <div className={css.singlee}></div>
            <div style={{ flex: "1" }}>{t("股票代码") + "：8076"}</div>
            <div className={css.lng} onClick={switchLanguage}>
              {i18n.language === "zh" ? "ZH" : "EN"}
            </div>
            <div className={css.menu} onClick={open}></div>
            {isClick ? (
              <div className={css.menuList}>
                <div className={css.triangle}></div>
                <div style={{ height: "100%", overflowY: "auto" }}>
                  <div className={css.menusearch}>
                    <input
                      className={css.iptbox}
                      value={keyword}
                      placeholder={t("$singlee_search")}
                      onChange={handleChangeIpt}
                    ></input>
                    <div className={css.search} onClick={goSearch}></div>
                  </div>
                  <div
                    className={`${css.menuItem} ${"/" + paths[1] === routes["home"] ? css.selectedFont : ""
                      }`}
                    onClick={() => goTo("home")}
                  >
                    {t("首页")}
                  </div>
                  <div
                    className={`${css.menuItem} ${"/" + paths[1] === "/prodandsolution" &&
                      paths[2] !== "solution"
                      ? css.selectedFont
                      : ""
                      }`}
                    style={{
                      background: "#d5d5d5",
                      marginBottom: prodFold ? 0 : "10px",
                    }}
                    onClick={productOpen}
                  >
                    {t("产品")}
                    <div
                      className={prodFold ? css.arrow : css.arrowClose}
                    ></div>
                  </div>
                  <div style={{ marginBottom: "10px" }}>
                    {product.map((item, index) => (
                      <div
                        className={`${prodFold ? css.subMenuItem : css.subMenuItemClose
                          } ${location.pathname === item.path
                            ? css.selectedFont
                            : ""
                          }`}
                        key={index}
                        onClick={() => goNavigate(item.path)}
                      >
                        {t(item.name)}
                      </div>
                    ))}
                  </div>
                  <div
                    className={`${css.menuItem} ${"/" + paths[1] === "/prodandsolution" &&
                      paths[2] === "solution"
                      ? css.selectedFont
                      : ""
                      }`}
                    style={{
                      background: "#d5d5d5",
                      marginBottom: solutionFold ? 0 : "10px",
                    }}
                    onClick={solutionOpen}
                  >
                    {t("解决方案")}
                    <div
                      className={solutionFold ? css.arrow : css.arrowClose}
                    ></div>
                  </div>
                  <div style={{ marginBottom: "10px" }}>
                    {solutions.map((item, index) => (
                      <div
                        className={`${solutionFold ? css.subMenuItem : css.subMenuItemClose
                          } ${location.pathname === item.path
                            ? css.selectedFont
                            : ""
                          }`}
                        key={index}
                        onClick={() => goNavigate(item.path)}
                      >
                        {t(item.name)}
                      </div>
                    ))}
                  </div>
                  <div
                    className={`${css.menuItem} ${"/" + paths[1] === routes["service"]
                      ? css.selectedFont
                      : ""
                      }`}
                    style={{
                      background: "#d5d5d5",
                      marginBottom: servieFold ? 0 : "10px",
                    }}
                    onClick={serviceOpen}
                  >
                    {t("服务")}
                    <div
                      className={servieFold ? css.arrow : css.arrowClose}
                    ></div>
                  </div>
                  <div style={{ marginBottom: "10px" }}>
                    {servie.map((item, index) => (
                      <div
                        className={`${servieFold ? css.subMenuItem : css.subMenuItemClose
                          } ${location.pathname === item.path
                            ? css.selectedFont
                            : ""
                          }`}
                        key={index}
                        onClick={() => goNavigate(item.path)}
                      >
                        {t(item.name)}
                      </div>
                    ))}
                  </div>
                  <div
                    className={`${css.menuItem} ${"/" + paths[1] === routes["news"]
                      ? css.selectedFont
                      : ""
                      }`}
                    style={{
                      background: "#d5d5d5",
                      marginBottom: servieFold ? 0 : "10px",
                    }}
                    onClick={newsOpen}
                  >
                    {t("新闻中心")}
                    <div
                      className={newsFold ? css.arrow : css.arrowClose}
                    ></div>
                  </div>
                  <div style={{ marginBottom: "10px" }}>
                    {newsList.map((item, index) => (
                      <div
                        className={`${newsFold ? css.subMenuItem : css.subMenuItemClose
                          } ${location.pathname === item.path
                            ? css.selectedFont
                            : ""
                          }`}
                        key={index}
                        onClick={() => goNavigate(item.path)}
                      >
                        {t(item.name)}
                      </div>
                    ))}
                  </div>

                  <div
                    className={`${css.menuItem} ${"/" + paths[1] === routes["notice"]
                      ? css.selectedFont
                      : ""
                      }`}
                    onClick={() => goTo("notice")}
                  >
                    {t("公司公告")}
                  </div>
                  <div
                    className={`${css.menuItem} ${"/" + paths[1] === routes["about"] ? css.selectedFont : ""
                      }`}
                    onClick={() => goTo("brief")}
                  >
                    {t("关于我们")}
                  </div>
                  <div
                    className={`${css.menuItem} ${"/" + paths[1] + "/" + paths[2] === routes["joinus"]
                      ? css.selectedFont
                      : ""
                      }`}
                    onClick={() => goTo("joinus")}
                  >
                    {t("加入我们")}
                  </div>
                  <div
                    className={`${css.menuItem} ${"/" + paths[1] + "/" + paths[2] === routes["board"]
                      ? css.selectedFont
                      : ""
                      }`}
                    onClick={() => goTo("board")}
                  >
                    {t("留言板")}
                  </div>
                </div>
              </div>
            ) : null}
          </div>
          {isClick ? <div className={css.mask} onClick={close}></div> : null}
        </div>
      ) : (
        <div className={css.pc} style={styles}>
          <div
            className={
              !isClick && transparent && !alwaysNotTransparant
                ? css.container
                : css.containerWhite
            }
          >
            <div className={css.logo}></div>
            <div>{t("股票代码") + "：8076"}</div>
            <div className={css.module}>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  marginLeft: "15px",
                }}
              >
                <div
                  className={`${css.item} ${"/" + paths[1] === routes["home"] ? css.active : ""
                    }`}
                  onClick={() => goTo("home")}
                  onMouseEnter={close}
                >
                  {t("首页")}
                </div>
                <div
                  onMouseEnter={open}
                  onClick={open}
                  className={`${css.item} ${"/" + paths[1] === "/prodandsolution" ? css.active : ""
                    }`}
                >
                  {t("产品")}
                </div>
                <div
                  onMouseEnter={open4}
                  onClick={open4}
                  className={`${css.item} ${"/" + paths[1] === "/service" ? css.active : ""
                    }`}
                >
                  {t("服务")}
                </div>
                <div
                  className={`${css.item} ${"/" + paths[1] === routes["news"] ? css.active : ""
                    }`}
                  onClick={() => goTo("newscenter")}
                  onMouseEnter={close}
                >
                  {t("新闻中心")}
                </div>
                <div
                  className={`${css.item} ${"/" + paths[1] === routes["notice"] ? css.active : ""
                    }`}
                  onClick={() => goTo("notice")}
                  onMouseEnter={close}
                >
                  {t("公司公告")}
                </div>
                <div
                  className={`${css.item} ${paths[1] === "join" || paths[1] === "about"
                    ? css.active
                    : ""
                    }`}
                  onMouseEnter={open2}
                  onClick={open2}
                >
                  {t("关于新利")}
                </div>
              </div>
            </div>
            <div className={css.search} onMouseEnter={open3}></div>
            <div className={css.ipt}>
              <div className={css.i18n}></div>
              <select
                className={css.select}
                onChange={changeLanguage}
                value={i18n.language}
              >
                <option value="zh">ZH</option>
                <option value="en">EN</option>
              </select>
            </div>
          </div>
          {isClick ? (
            <div>
              <div className={css.subnav} onMouseLeave={close}>
                {isJoin === 1 ? (
                  <>
                    <div className={css.box}>
                      <div
                        className={css.boxtitle}
                        style={{ cursor: "pointer" }}
                        onClick={() => {
                          goNavigate("/prodandsolution/prod");
                        }}
                      >
                        {t("产品")}
                      </div>
                      <div
                        className={css.boxtitle2}
                        style={{ cursor: "pointer", top: `${wdHeight}px` }}
                        onClick={() => {
                          goNavigate("/prodandsolution/solution/retail");
                        }}
                      >
                        {t("解决方案")}
                      </div>
                      <div className={css.boxitemContainer}>
                        {product.map((item, index) => (
                          <div
                            className={css.boxitem}
                            key={index}
                            style={{
                              marginRight: index % 2 === 0 ? "2%" : "0",
                            }}
                            onClick={() => goNavigate(item.path)}
                          >
                            <div style={{ marginRight: "10px" }}>{">"}</div>
                            <div className={css.right}>{t(item.name)}</div>
                          </div>
                        ))}
                      </div>
                      <div
                        ref={heightel}
                        className={css.boxitemContainer}
                        style={{ marginTop: "40px" }}
                      >
                        {solutions.map((item, index) => (
                          <div
                            className={css.boxitem}
                            key={index}
                            style={{
                              marginRight: index % 2 === 0 ? "2%" : "0",
                            }}
                            onClick={() => goNavigate(item.path)}
                          >
                            <div style={{ marginRight: "10px" }}>{">"}</div>
                            <div className={css.right}>{t(item.name)}</div>
                          </div>
                        ))}
                      </div>
                    </div>
                    <div className={css.boxNone}>
                      {/* <div className={css.boxtitle}>{t("服务")}</div>
                      <div className={css.boxitemContainer}>
                        {servie.map((item, index) => (
                          <div
                            style={{ width: "100%" }}
                            className={css.boxitem}
                            key={index}
                            onClick={() => goNavigate(item.path)}
                          >
                            <div style={{ marginRight: "10px" }}>{">"}</div>
                            <div className={css.right}>{t(item.name)}</div>
                          </div>
                        ))}
                      </div> */}
                    </div>
                  </>
                ) : isJoin === 4 ? (
                  <>
                    <div className={css.box}>
                      <div className={css.boxtitle}>{t("服务")}</div>
                      <div className={css.boxitemContainer}>
                        {servie.map((item, index) => (
                          <div
                            style={{ width: "100%" }}
                            className={css.boxitem}
                            key={index}
                            onClick={() => goNavigate(item.path)}
                          >
                            <div style={{ marginRight: "10px" }}>{">"}</div>
                            <div className={css.right}>{t(item.name)}</div>
                          </div>
                        ))}
                      </div>
                    </div>
                    <div className={css.boxNone}></div>
                  </>
                ) : isJoin === 2 ? (
                  <>
                    <div className={css.box}>
                      <div className={css.boxtitle}>{t("关于我们")}</div>
                      <div className={css.boxitemContainer}>
                        {aboutusList.map((item, index) => (
                          <div
                            className={css.boxitem}
                            key={index}
                            style={{
                              marginRight: index % 2 === 0 ? "2%" : "0",
                            }}
                            onClick={() => goNavigate(item.path)}
                          >
                            <div style={{ marginRight: "10px" }}>{">"}</div>
                            <div className={css.right}>{t(item.name)}</div>
                          </div>
                        ))}
                      </div>
                    </div>
                    <div className={css.box}>
                      <div className={css.boxtitle}>{t("加入我们")}</div>
                      <div className={css.boxitemContainer}>
                        {joinusList.map((item, index) => (
                          <div
                            style={{ width: "100%" }}
                            className={css.boxitem}
                            key={index}
                            onClick={() => goNavigate(item.path)}
                          >
                            <div style={{ marginRight: "10px" }}>{">"}</div>
                            <div className={css.right}>{t(item.name)}</div>
                          </div>
                        ))}
                      </div>
                    </div>
                  </>
                ) : (
                  <>
                    <div className={css.searchbox}>
                      <input
                        className={css.ipt}
                        value={keyword}
                        placeholder={t("$singlee_search")}
                        onKeyUp={handleKeyUp}
                        onChange={handleChangeIpt}
                      />
                      <div className={css.search} onClick={goSearch}></div>
                    </div>
                  </>
                )}
              </div>
              <div className={css.mask} onClick={close}></div>
            </div>
          ) : null}
        </div>
      )}
    </>
  );
};

export default React.memo(Nav);
